'use strict';
var app = require('angular').module('directive.toast', []);

app.factory('toast', ['$timeout', require('./toastFactory')]);
app.directive('toastDirective', [require('./toastDirective')]);
